import React from "react";
import {connect} from "react-redux";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {Paper, Typography} from "@material-ui/core";
import Gota from "../../../icons/PNGs/gota.png";
import Termometro from "../../../icons/PNGs/termometro.png";
import {IParcela} from "../../../types";

import cielo_1 from "../../../icons/iconos_tiempo/1.svg";
import cielo_2 from "../../../icons/iconos_tiempo/2.svg";
import cielo_3 from "../../../icons/iconos_tiempo/3.svg";
import cielo_4 from "../../../icons/iconos_tiempo/4.svg";
import cielo_5 from "../../../icons/iconos_tiempo/5.svg";
import cielo_6 from "../../../icons/iconos_tiempo/6.svg";
import cielo_7 from "../../../icons/iconos_tiempo/7.svg";
import cielo_8 from "../../../icons/iconos_tiempo/8.svg";
import cielo_9 from "../../../icons/iconos_tiempo/9.svg";
import cielo_10 from "../../../icons/iconos_tiempo/10.svg";
import cielo_11 from "../../../icons/iconos_tiempo/11.svg";
import cielo_12 from "../../../icons/iconos_tiempo/12.svg";
import cielo_13 from "../../../icons/iconos_tiempo/13.svg";
import cielo_14 from "../../../icons/iconos_tiempo/14.svg";
import cielo_15 from "../../../icons/iconos_tiempo/15.svg";
import cielo_16 from "../../../icons/iconos_tiempo/16.svg";
import cielo_17 from "../../../icons/iconos_tiempo/17.svg";
import cielo_18 from "../../../icons/iconos_tiempo/18.svg";
import cielo_19 from "../../../icons/iconos_tiempo/19.svg";
import cielo_20 from "../../../icons/iconos_tiempo/20.svg";
import cielo_21 from "../../../icons/iconos_tiempo/21.svg";
import cielo_22 from "../../../icons/iconos_tiempo/22.svg";


const CieloIcons: Record<number, any> = {
    1: cielo_1,
    2: cielo_2,
    3: cielo_3,
    4: cielo_4,
    5: cielo_5,
    6: cielo_6,
    7: cielo_7,
    8: cielo_8,
    9: cielo_9,
    10: cielo_10,
    11: cielo_11,
    12: cielo_12,
    13: cielo_13,
    14: cielo_14,
    15: cielo_15,
    16: cielo_16,
    17: cielo_17,
    18: cielo_18,
    19: cielo_19,
    20: cielo_20,
    21: cielo_21,
    22: cielo_22
}



const texts = require('../../../texts/riegoneto.json')

interface IProps {
    pronostico: Record<string, Record<string, number>>
    idioma: string
}

interface Istate {
    text: Record<string, string>
}

class Pronostico extends React.Component<IProps, Istate> {

    state: Istate = {
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    getColor = (k: string) => {
        let cnt = 0
        for (const el of Object.keys(this.props.pronostico).slice(0, 7)) {
            cnt += 1
            if (el === k) break
        }
        if (cnt%2 === 0) return '#eee'
        else return '#eee'
    }

    render() {
        console.log(this.props.pronostico)
        const dias = this.state.text["23"].split(',')
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    height: '100%'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: 30,
                        marginLeft: 40,
                        marginTop: 5,
                        width: '100%',
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["24"]}
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 20,
                        width: '95%'
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            marginTop: 20,
                            justifyContent: "space-between"
                        }}
                    >
                        <div
                            style={{width: '25%'}}
                        >
                            <Typography
                                style={{fontWeight: "bold", marginLeft: 30, fontFamily: "Poppins"}}
                            >
                                {this.state.text["25"]}
                            </Typography>
                        </div>
                        <div
                            style={{width: '25%'}}
                        >
                            <Typography
                                style={{fontWeight: "bold", fontFamily: "Poppins"}}
                            >
                                {this.state.text["52"]}
                            </Typography>
                        </div>
                        <div
                            style={{width: '25%'}}
                        >
                            <Typography
                                style={{fontWeight: "bold", fontFamily: "Poppins"}}
                            >
                                {this.state.text["26"]}
                            </Typography>
                        </div>
                        <div
                            style={{width: '25%'}}
                        >
                            <Typography
                                style={{fontWeight: "bold", fontFamily: "Poppins"}}
                            >
                                {this.state.text["27"]}
                            </Typography>
                        </div>
                    </div>



                    {Object.keys(this.props.pronostico).slice(0, 5).map((k, i) =>
                        <div
                            key={k}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: 50,
                                alignItems: "center",
                                backgroundColor: this.getColor(k),
                                justifyContent: "space-between"
                            }}
                        >
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '25%'
                            }}>
                                {i === 0?
                                    <Typography style={{marginLeft: 30, width: 80, marginRight: 5, fontFamily: "Poppins"}}>
                                        {this.state.text["53"]}
                                    </Typography>
                                    :
                                    <Typography style={{marginLeft: 30, width: 80, marginRight: 5, fontFamily: "Poppins"}}>
                                        {dias[new Date(k).getDay()]}
                                    </Typography>
                                }
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '25%'
                                }}
                            >
                                <img
                                    style={{
                                        height: 40
                                    }}
                                    src={CieloIcons[parseInt((this.props.pronostico[k]['cielo_id']).toString())]}
                                    alt="sky img"
                                />

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '25%'
                                }}
                            >
                                <img
                                    style={{
                                        marginRight: 10,
                                        height: 20
                                    }}
                                    src={Gota}
                                    alt="gota img"
                                />

                                <Typography style={{fontFamily: "Poppins"}}>
                                    {this.props.pronostico[k]['lluvia']} mm
                                </Typography>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "25%"
                                }}
                            >
                                <img
                                    style={{
                                        marginRight: 5,
                                        height: 20,
                                        width: 20
                                    }}
                                    src={Termometro}
                                    alt="gota img"
                                />
                                <Typography style={{fontFamily: "Poppins"}}>
                                    {this.props.pronostico[k]['t_max']} ºC / {this.props.pronostico[k]['t_min']} ºC
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div
                        style={{
                            width: '100%',
                            height: 20,
                            direction: 'rtl',
                            marginTop: 20
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 13,
                                color: '#555',
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["28"]} <a target={'_blank'} href="https://www.tiempo.com/mundo.htm">METEORED</a>
                        </Typography>
                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    pronostico: state.riego.pronostico,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Pronostico);
